export enum SortBy {
  HighToLow = 'SCROLLABLE_AREA.COLOR.PRICE_HIGH_TO_LOW',
  LowToHigh = 'SCROLLABLE_AREA.COLOR.PRICE_LOW_TO_HIGH',
  NameAZ = 'SCROLLABLE_AREA.COLOR.NAME_A_Z',
  NameZA = 'SCROLLABLE_AREA.COLOR.NAME_Z_A',
  TrendingNow = 'SCROLLABLE_AREA.COLOR.TRENDING_NOW',
}
